import './scss/main.scss';

import App from "./js/core/App.js";

new App();